import { createMuiTheme } from "@material-ui/core/styles";

const theme = createMuiTheme({
  palette: {
    primary: { main: "#212B36" },
    secondary: { main: "#FFFFFF" },
    tertiary: { main: "#BD311F" },
  },

  overrides: {
    MuiTypography: {
      h1: {
        fontSize: "40px",
        fontFamily: "manrope-bold-webfont",
        lineHeight: "48px",
      },
      h2: {
        fontFamily: "manrope-bold-webfont",
        fontSize: "20px",
      },
      body1: {
        fontSize: "16px",
        fontFamily: "manrope-semibold-webfont",
        lineHeight: "24px",
      },
    },
    MuiButton: {
      root: {
        fontFamily: "manrope-semibold-webfont",
        fontSize: "16px",
        padding: "16px 32px",
        borderRadius: "8px",
        textTransform: "none",
      },
      label: { fontFamily: "manrope-semibold-webfont", fontSize: "16px" },
      text: { fontFamily: "manrope-semibold-webfont", fontSize: "16px" },
      containedPrimary: {
        backgroundColor: "#BD311F",
        color: "#ffffff",
        "&:hover": {
          backgroundColor: "rgb(189, 49, 31)",
        },
      },
      containedSecondary: {
        backgroundColor: "#FFFFFF",
        color: "#BD311F",
        border: "1px solid #BD311F",
        boxShadow: "none",
        "&:hover": {
          backgroundColor: "rgb(253, 242, 242)",
        },
      },
    },
    MuiCssBaseline: {
      root: { fontFamily: "manrope-semibold-webfont" },
    },
  },
});

export default theme;



// WEBPACK FOOTER //
// ./js/components/helpers/theme.js